import { AlphaXCircleOutlineIcon } from './AlphaXCircleOutlineIcon';

/**
 * author: Contributors
 * id 8B9761E9-9101-4850-8DCA-D8B63193A20B
 * name alpha-x-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-x-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetXCircleOutlineIcon = AlphaXCircleOutlineIcon;
export default AlphabetXCircleOutlineIcon